import { useEffect } from "react";
import AdminLayout from "../AdminLayout";
import { useUserHook } from "./hooks/userHook";
import Spinner from "react-bootstrap/Spinner";

const AllUsers = () => {
  const {
    totalPageCount,
    currentPage,
    allusersArr,
    isNextPage,
    isPrevPage,
    fetchUserData,
    goToNextPage,
    goToPrevPage,
    goToPage,
    selectedUser,
    setSelectedUser,
    loading,
  } = useUserHook();


  useEffect(() => {
    const allusers = async () => {
      await fetchUserData();
    };
    allusers();
  }, [currentPage, totalPageCount]);

  return (
    <>
      <AdminLayout>
        {loading ? (
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        ) : (
          <div className="listed_users_weeper">
            <div className="sale_by_states_wepper">
              <div className="container">
                <div className="row">
                  {/*  user table */}
                  <div className={!selectedUser ? "col-lg1" : "col-lg-8"}>
                    <div className="sales_sec">
                      <div className="sales_hedding">
                        <p>
                          <strong>Listed Users</strong>
                        </p>
                        <div className="divider_only"></div>

                        {/* table headers */}
                        <div className="row mt-4 justify-content-center">
                          <div className="col-lg-4 p-0">
                            <div className="golob_hedding">
                              <h3>Name</h3>
                            </div>
                          </div>
                          <div className="col-lg-2 p-0">
                            <div className="golob_hedding">
                              <h3>ID</h3>
                            </div>
                          </div>
                          <div className="col-lg-2 p-0">
                            <div className="golob_hedding">
                              <h3>Role</h3>
                            </div>
                          </div>
                          <div className="col-lg-2 p-0">
                            <div className="golob_hedding">
                              <h3>State</h3>
                            </div>
                          </div>
                          <div className="col-lg-2 p-0">
                            <div className="golob_hedding">
                              <h3>Phone</h3>
                            </div>
                          </div>
                        </div>

                        {/* table content starts here */}
                        {allusersArr.map((user, index) => (
                          <div
                            key={index}
                            className="table_row row mt-4 justify-content-center"
                            onClick={() => setSelectedUser(user)}
                          >
                            <div className="col-lg-4 p-0">
                              <div className="golob_hedding_inner">
                                <div className="table_user">
                                  <img
                                    src={
                                      user?.gender === "male"
                                        ? "/images/man.png"
                                        : "/images/woman.png"
                                    }
                                    alt=""
                                  />
                                  <div>
                                    <h4>
                                      {user?.first_name} {user?.last_name}
                                    </h4>
                                    <span>{user?.email}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-2 p-0">
                              <div className="golob_hedding_inner">
                                <h3>{user?.employee_id}</h3>
                              </div>
                            </div>
                            <div className="col-lg-2 p-0">
                              <div className="golob_hedding_inner">
                                <h3>{user?.role}</h3>
                              </div>
                            </div>
                            <div className="col-lg-2 p-0">
                              <div className="golob_hedding_inner">
                                <h3>{user?.state}</h3>
                              </div>
                            </div>
                            <div className="col-lg-2 p-0">
                              <div className="golob_hedding_inner">
                                <h3>{user?.phone}</h3>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className="divider_only"></div>
                      <div className="row align-items-center pagination_weepr">
                        <div className="col-lg-4">
                          <span>
                            Showing {currentPage} of {totalPageCount} pages
                          </span>
                        </div>
                        <div className="col-lg-8">
                          <nav aria-label="Page navigation">
                            <ul className="pagination justify-content-end">
                              <li
                                className={`page-item ${
                                  !isPrevPage && "disabled"
                                }`}
                              >
                                <button
                                  className="page-link prev_text"
                                  onClick={goToPrevPage}
                                  disabled={!isPrevPage}
                                >
                                  Prev
                                </button>
                              </li>

                              {/* Render page numbers dynamically */}
                              {[...Array(totalPageCount)].map((_, index) => {
                                const page = index + 1;
                                return (
                                  <li
                                    key={page}
                                    className={`page-item ${
                                      currentPage === page && "active"
                                    }`}
                                  >
                                    <button
                                      className="page-link"
                                      onClick={() => goToPage(page)}
                                    >
                                      {page}
                                    </button>
                                  </li>
                                );
                              })}

                              <li
                                className={`page-item ${
                                  !isNextPage && "disabled"
                                }`}
                              >
                                <button
                                  className="page-link next_setp"
                                  onClick={goToNextPage}
                                  disabled={!isNextPage}
                                >
                                  Next
                                </button>
                              </li>
                            </ul>
                          </nav>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* user profile details */}
                  <div
                    style={{ wordWrap: "break-word" }}
                    className={!selectedUser ? "hideContent" : "col-lg-4"}
                  >
                    <div className="user_profile_wepper">
                      <div className="user_id">
                        <span>ID: {selectedUser?.employee_id}</span>
                      </div>
                      <div className="all_user_profile">
                        <img
                          style={{ width: "130px", height: "130px" }}
                          src={
                            selectedUser?.gender === "male"
                              ? "/images/man.png"
                              : "/images/woman.png"
                          }
                          alt="img_profile"
                        />
                        <div className="user_name">
                          <h2>
                            {selectedUser?.first_name} {selectedUser?.last_name}
                          </h2>
                          <p>{selectedUser?.designation}</p>
                        </div>

                        <div className="alluser_divder"></div>
                        <div className="all_user_about">
                          <h2>About</h2>
                          <p>
                            Hi, My Name is {selectedUser?.first_name}{" "}
                            {selectedUser?.last_name} 😊 and I am working as a{" "}
                            {selectedUser?.designation} at unboxed.in 🚀!!
                            Currently live in{" "}
                            <b style={{ letterSpacing: "2px" }}>
                              {selectedUser?.city}
                            </b>
                            .
                          </p>
                        </div>

                        <div className="row mt-3">
                          <div className="col-lg-6">
                            <div className="all_user_age">
                              <h3>Phone</h3>
                              <span>+91 {selectedUser?.phone}</span>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="all_user_age">
                              <h3>Email</h3>
                              <span>{selectedUser?.email}</span>
                            </div>
                          </div>
                        </div>

                        <div className="row mt-3">
                          <div className="col-lg-6">
                            <div className="all_user_age">
                              <h3>Age</h3>
                              <span>
                                {selectedUser?.birth_date
                                  ? Math.floor(
                                      (new Date() -
                                        new Date(selectedUser?.birth_date)) /
                                        (1000 * 60 * 60 * 24 * 365.25)
                                    )
                                  : ""}
                              </span>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="all_user_age">
                              <h3>Gendar</h3>
                              <span>{selectedUser?.gender}</span>
                            </div>
                          </div>
                        </div>

                        <div className="row mt-3">
                          <div className="col-lg-6">
                            <div className="all_user_age">
                              <h3>Date of birth</h3>
                              <span>
                                {selectedUser?.birth_date
                                  ? new Date(
                                      selectedUser?.birth_date
                                    ).toLocaleDateString("en-GB", {
                                      day: "numeric",
                                      month: "long",
                                      year: "numeric",
                                    })
                                  : ""}
                              </span>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="all_user_age">
                              <h3>Address</h3>
                              <span>
                                {selectedUser?.address1},
                                {selectedUser?.address2}, {selectedUser?.city},{" "}
                                {selectedUser?.state}, {selectedUser?.pincode}
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="row mt-3">
                          <div className="col-lg-6">
                            <div className="all_user_age">
                              <h3>Designation</h3>
                              <span>{selectedUser?.designation}</span>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="all_user_age">
                              <h3>Department</h3>
                              <span>{selectedUser?.department}</span>
                            </div>
                          </div>
                        </div>

                        <div className="row mt-3">
                          <div className="col-lg-6">
                            <div className="all_user_age">
                              <h3>Role</h3>
                              <span>{selectedUser?.role}</span>
                            </div>
                          </div>
                        </div>

                        <div className="edit_delete_button row mt-5 justify-content-start">
                          <div className="col-lg-12">
                            <div className="row">
                              <div
                                style={{ cursor: "pointer" }}
                                className="col-lg-6"
                              >
                                <p>Edit User</p>
                              </div>
                              <div
                                style={{ cursor: "pointer" }}
                                className="col-lg-6 continue_step"
                              >
                                <p className="active">Delete User</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </AdminLayout>
    </>
  );
};

export default AllUsers;
